(function () {
    "use strict";

    var DEFAULT_MESSAGES_PER_PAGE = 15;

    // @ngInject
    function ConversationsManagerCtor($q, APIService, Routes, $injector, ModelFactory) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);
        this.Routes = Routes;
        this.$injector = $injector;
        this.lastConversationFetchTime = {};
    }

    Services.ConversationsManager = Class(Services.BaseModelManager, {

        constructor: ConversationsManagerCtor,


        getDefaultMessagesPerPage: function getDefaultMessagesPerPage(){
            return DEFAULT_MESSAGES_PER_PAGE;
        },

        sendConversationMessage: function sendConversationMessage(conversation, messageHTML) {
            var message = {
                html_body: messageHTML
            };

            var url = this.Routes.v2_conversation_send_conversation_message_path(conversation._id);
            return this.apiCreate(url, message, null, false);
        },

        getConversation: function getConversation(conversation, latestTS, earliestTS) {

            var date;
            if (!this.lastConversationFetchTime[conversation._id]) {
                date = new Date();
                this.lastConversationFetchTime[conversation._id] = date.getTime();
            } else {
                var lastRequestForThisConversation = this.lastConversationFetchTime[conversation._id];
                date = new Date();
                var now = date.getTime();
                var secondsSinceLastRequestForThisConversation = ((now - lastRequestForThisConversation)/1000);
                if(secondsSinceLastRequestForThisConversation < 1){
                    return;
                } else {
                    this.lastConversationFetchTime[conversation._id] = date.getTime();
                }
            }

            var url = this.Routes.v2_conversation_get_conversation_path(conversation._id);

            // we only want to limit for loading early messages. if we fetch new messages we want all messages since
            // the last one we currently have
            var perPage = (latestTS && !earliestTS ? null : DEFAULT_MESSAGES_PER_PAGE);
            var data = {later_than: latestTS, earlier_than: earliestTS, per_page: perPage};

            return this.apiFetch(url, data);
        },

        getOrCreateConversation: function getOrCreateConversation(userIds) {

            var message = {
                user_ids: userIds
            };

            var url = this.Routes.v2_conversation_create_conversation_path();
            return this.apiCreate(url, message, null, false);
        },

        getConversationItemsAfter: function getConversationItemsAfter(conversation) {

            var url = this.Routes.v2_conversation_get_conversation_feed_items_path(conversation._id, conversation.last_item_ts);
            return this.apiFetch(url);
        },

        optIntoConversation: function optIntoConversation(conversationId, user){

            //Just a dirty hack for cirular dependancy
            if(!this.UsersManager){
                this.UsersManager = this.$injector.get('UsersManager');
            }
            var currUser = this.UsersManager.getCurrUser();
            var url = this.Routes.v2_user_opt_in_to_channel_path(conversationId);

            return this.apiUpdate(url, null, currUser, true);
        }

    });
}());
